import React from 'react';
import { IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import history from 'services/history';

const ProfileActions: React.FC = () => {
  return (
    <>
      <IconButton color="inherit" onClick={() => history.push('/user-profile')}>
        <AddIcon />
      </IconButton>
    </>
  );
};

export default ProfileActions;
